module.exports = __webpack_public_path__ + "img/con_c_type.73c8f891.jpg";